import React, { useState, useRef, useEffect } from "react";
import { MdExpandMore, MdLanguage } from "react-icons/md";

const CustomSelect = ({
  value,
  options,
  onChange,
  placeholder = "Select option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value);
  const selectedLabel = selectedOption ? selectedOption.label : placeholder;

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full bg-white rounded-lg mt-2 py-2 px-4 flex items-center justify-between cursor-pointer border border-transparent hover:border-gray-200 transition-all duration-200 ${isOpen ? "ring-2 ring-purple-500" : ""}`}
      >
        <div className="flex items-center gap-3 overflow-hidden">
          <MdLanguage className="text-black text-2xl flex-shrink-0" />
          <span className="text-black text-base font-medium truncate atkinson-font tracking-tight">
            {selectedLabel}
          </span>
        </div>
        <MdExpandMore
          className={`text-gray-600 text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
        />
      </div>

      <div
        className={`absolute top-full left-0 w-full mt-2 bg-white rounded-lg shadow-xl overflow-hidden z-50 transition-all duration-200 origin-top transform ${isOpen ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 -translate-y-2 pointer-events-none"}`}
      >
        <div className="max-h-60 overflow-y-auto py-3 px-6">
          <span className="text-base atkinson-font tracking-tight mb-1">
            Select Language:
          </span>
          {options.map((option) => (
            <div
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setIsOpen(false);
              }}
              className={`px-8 py-2 text-sm text-black cursor-pointer transition-colors flex items-center justify-between rounded-md  ${value === option.value ? "bg-[#28094C] text-white" : "hover:bg-purple-100"}`}
            >
              <span
                className={`atkinson-font tracking-tight ${value === option.value ? "text-white" : ""}`}
              >
                {option.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomSelect;
